import {Back, Sine, TimelineLite} from "gsap";
import {Application} from "../Application";
import {AppProgress} from "../Data/AppProgress";
import * as Constants from "../Data/Constants";
import {GameType} from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import {screen} from "../Layout/PuppetLayout";
import {Sprite} from "../Utils/Sprite";
import {GalleryItem} from "./GalleryItem";
import {PuppetScreen} from "./PuppetScreen";

export class GalleryPuppet extends GalleryItem {

    constructor(pCallback: (pItem: GalleryItem) => void) {
        super(GameType.PUPPET, pCallback);

        this._homePos = new PIXI.Point(320, -220);
        this._homeScale = 0.65;
        this._targetState = Constants.STATE_PUPPET;
        this._hoverVO = VoiceOver.PUPPET_BUTTON;

        this.createVisuals();
    }

    public cacheVisuals(): PIXI.Texture {
        return Application.instance.renderer.generateTexture(
            this._visuals,
            undefined,
            Application.instance.renderer.resolution,
        );
    }

    public presentItem(): TimelineLite {
        this.interactive = false;
        this.x = 0;
        this.y = -120;
        this.scale.set(2.5);
        const timeline = new TimelineLite();
        timeline.from(this, 1.6, {
            y: -(Application.instance.size.y + this.height) * 0.5,
            ease: Back.easeOut,
        }, 0);
        return timeline;
    }

    public moveItemToWall(): TimelineLite {
        const t = 1;
        const timeline = new TimelineLite();
        timeline.to(this, t, {
            x: this._homePos.x,
            y: this._homePos.y,
            ease: Sine.easeInOut,
        }, 0);
        timeline.to(this.scale, t, {
            x: 1,
            y: 1,
            ease: Sine.easeInOut,
        }, 0);
        return timeline;
    }

    protected createVisualDefault(): void {
        const sprite = new Sprite("menu-button-shadowpuppet", 0.5);
        sprite.scale.set(this._homeScale);
        this._visuals.addChild(sprite);
        this.position.copy(this._homePos);
    }

    protected createVisualComplete(): void {
        const s = this.createScreen();
        s.scale.set(this._homeScale * 0.25);
        this._visuals.addChild(s);
        this.position.copy(this._homePos);
    }

    protected createVisualCached(): void {
        super.createVisualCached();
        this._cached!.scale.set(this._homeScale);
    }

    private createScreen(): PuppetScreen {
        const s = new PuppetScreen();
        screen.call(s);
        s.ropeLeft.visible = false;
        s.ropeRight.visible = false;
        s.load(AppProgress.games[this._gameType].saveData[0]);
        return s;
    }
}
